import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';

export const BlogDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute bottom-[-64px] right-[10%] h-32 w-32 md:right-28 md:h-40 md:w-40"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute bottom-8 left-[25%] h-11 w-11 md:left-auto md:right-20 md:top-20"
    />
    <DynamicDecorator
      decorator="halfStadium"
      className="absolute right-14 top-[-18px] h-12 w-12 text-gray-100 md:right-[30%] md:top-[-50px] md:h-20 md:w-20"
    />
  </>
);
